export default {
  grid: {
    container: '130rem',
    gutter: '3.2rem'
  },
  border: {
    radius: '0.4rem'
  },
  font: {
    family: 'IBMPlexSans-Regular, "Segoe UI", sans-serif',
    light: 300,
    normal: 400,
    bold: 600,
    extraBold: 700,
    sizes: {
      xsmall: '1.2rem',
      small: '1.4rem',
      medium: '1.6rem',
      large: '1.8rem',
      xlarge: '2.0rem',
      xxlarge: '2.8rem',
      huge: '5.2rem'
    }
  },
  colors: {
    primary: '#006B3F',
    primary3: '#54BC82',
    secondary: '#079D56',
    secondary2: '#FF8B22',
    complementary: '#00D38D',
    mainBg: '#F8F9FA',
    lightBg: '#F2F2F2',
    white: '#FFFFFF',
    black: '#242625',
    lightGray: '#D9DDDB',
    gray: '#5D615F',
    gray1: '#434844',
    gray2: '#EDF2F0',
    gray3: '#5D615F',
    gray4: '#999E9C',
    gray6: '#F0F2F1',
    darkGray: '#434645',
    red: '#FF6347',
    yellow: '#FFEA93',
    lightGreen: '#E5F3EB',
    lightRed: '#FFD1CA',
    orange1: '#FFF2E3',
    orange2: '#AD5400',
    red2: '#922717',
    red3: '#FFECEC',
    red4: '#E04C36',
    blue: '#2E37E5',
    blue2: '#E3EBFF',
    blue3: '#11188D'
  },
  spacings: {
    xxsmall: '0.8rem',
    xsmall: '1.6rem',
    small: '2.4rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '5.6rem'
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50
  },
  transition: {
    default: '0.3s ease-in-out',
    fast: '0.1s ease-in-out'
  }
} as const
